<style lang="less" scoped>
.dhxwList{position: relative;width: 100%;display: flex;flex-direction: column;justify-content: center;align-items: center;margin: 0;padding: 0;background: #fff;}
.mains{position: relative;width: 800px;display: flex;}
.first{display: flex;flex-direction: column;width: 780px;margin-right: 20px;}
p{text-align:left;}
.title{line-height: 50px;display: flex; flex-direction: column;margin-top: 10px;
  span{font-size: 36px;margin-left: 60px;}
  i{width: 760px; height: 3px;display: inline-block;background: #3c77bb;margin: auto;}
}
.subtitle{font-size: 25px;font-weight: 600; margin-left: 60px;margin-top: 0px;}
.list{margin-left: 90px;}
.sub{margin-left: 60px;color: #3c77bb;font-size: 20px;}
</style>

<template>
  <div class="dhxwList">
    <div class="mains">
      <div class="first">
        <p class="title"><span>2021论坛概况</span><i></i></p>
        <p class="subtitle">2021（第十一届）中国东盟矿业合作论坛暨推介展示会概况</p>
        <p class="list">● 中国—东盟博览会、中国—东盟商务与投资峰会系列重要活动之一</p>
        <p class="list">● 中国—东盟国家矿业主管部门级别最高的官方盛会</p>
        <p class="list">● 中国—东盟规模最大的国际矿业盛会</p>
        <p style="margin: 0px 30px; margin-left: 60px;line-height: 30px;">中国—东盟矿业合作论坛暨推介展示会（以下简称“矿业论坛”）是中国与东盟、“一带一路”沿线国家矿业领域合作的重要平台，作为中国—东盟博览会、中国—东盟商务与投资峰会框架下系列重要活动，迄今已成功举办了十届，并取得丰硕成果，现已发展成为中国与东盟国家共同举办的级别最高、规模最大的国际矿业盛会。</p>
        <p class="sub">一、时间和地点</p>
        <p class="list">● 时间：2021年5月19日至21日</p>
        <p class="list">● 地点：广西南宁国际会展中心、会展豪生大酒店</p>
        <p class="list">● 规模：约400人</p>
        <p class="list">● 形式：“线上+线下”相结合；出席线下活动的外宾只邀请长期在华工作的外国驻华使领馆官员代表及国际矿业组织、商协会、企业、高校和科研机构驻华代表，境外人员只邀请参加线上活动。</p>
        <p class="sub">二、主题及议题</p>
        <p style="margin-left: 60px;">主题：共建“一带一路” 共兴绿色矿业</p>
        <p class="list">● 矿业转型升级绿色发展政策与实践</p>
        <p class="list">● 绿色矿山企业发展</p>
        <p class="list">● 矿业项目与技术合作</p>
        <p class="list">● 重要矿产资源开发与利用</p>
        <p class="list">● 地学合作机制与前景</p>
        <p class="list">● 地质矿产与矿业信息化服务</p>
        <p class="list">● 卫星遥感技术运用与合作</p>
        <p class="list">● 矿山生态修复标准与探索实践</p>
        <p class="sub">三、主要活动</p>
        <p class="list">● 开幕式</p>
        <p class="list">● 中国—东盟地调局长论坛</p>
        <p class="list">● 中国—东盟地学高校校长论坛</p>
        <p class="list">● 中国—东盟矿业转型升级绿色发展政策与实践研讨会</p>
        <p class="list">● 中国—东盟绿色矿山企业发展研讨会</p>
        <p class="list">● 中国—东盟矿山生态修复技术研讨会</p>
        <p class="list">● 东盟国家矿业专场推介会</p>
        <p class="list">● 中国—东盟矿业法律政策研讨会</p>
        <p class="list">● 中国—东盟岩溶地质对比研究与编图研讨会</p>
        <p class="list">● 中国—东盟黄金产业发展暨广西黄金地质找矿研讨会</p>
        <p class="list">● 中国—东盟卫星遥感研讨会</p>
        <p class="list">● 中国—东盟地学科普合作研讨会</p>
        <p class="list">● 中国—东盟矿业人才培训班</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  data()
  {
    return {
      list: []
    }
  },
  created()
  {
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/project/Ltgk.vue